import useSWR from "swr";
import { fetcher } from "../components/Overview/Overview";
import { useDebounce } from "../utils/debounce";

// Function which fetches results from the server using SWR)
export function getUsers(stateToDebounce) {
    const state = useDebounce(stateToDebounce, 300);

    let filtering = "";

    if (state?.filter) {
        filtering =
            "&" +
            Object.entries(state.filter)
                .filter((o) => o[1] !== "" && o[1] !== null && o[1] !== undefined && o[1]?.length !== 0)
                .map((obj, idx) => {
                    const [key, value] = obj;
                    return `${key}=${Array.isArray(value) ? value.join("&" + key + "=") : value}`;
                })
                .join("&");
    }

    const fields = state?.columns?.length > 0 ? "&fields=" + state?.columns?.map((o) => o.columnIdentifier).join(",") : "";

    let ordering = (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "name");

    // Use SWR accepts both an url or a function as its first param.
    // When passing an url it uses the URL as a cache key, fetches the result, and stores it for the default amount of time
    // When passing a function, the function can evaluate vars before returning the URL. This is usefull for 2 checking
    // if required params or dependencies are set. When a falsy result is returned it is handled as a non-call
    // Please note: as SWR is a Hook, it should always return the same result (even if something is wrong!)
    // Therefore you can not just return false to the one calling getCourses
    return useSWR(
        () => (state?.identifier ? `/v1/users/?offset=${state.offset}${fields}&is_active=true&limit=${state.size}&ordering=${ordering}${filtering}` : false),
        fetcher
    );
}
